function getFavourites() {
    try {
        return JSON.parse(localStorage.getItem('recipe_favourites') || '[]');
    }
    catch (_a) {
        return [];
    }
}
function isFavourite(id) {
    return getFavourites().includes(id);
}
function toggleFavourite(id) {
    const favourites = getFavourites();
    const index = favourites.indexOf(id);
    if (index > -1) {
        favourites.splice(index, 1);
    }
    else {
        favourites.push(id);
    }
    localStorage.setItem('recipe_favourites', JSON.stringify(favourites));
}
export function initFavourites() {
    const favouriteBtn = document.querySelector('.favourite-btn');
    const recipeId = favouriteBtn === null || favouriteBtn === void 0 ? void 0 : favouriteBtn.dataset.recipeId;
    if (favouriteBtn && recipeId) {
        if (isFavourite(recipeId)) {
            favouriteBtn.classList.add('is-favourited');
        }
        favouriteBtn.addEventListener('click', function () {
            toggleFavourite(recipeId);
            this.classList.toggle('is-favourited');
        });
    }
}
export function initRecipeFilters() {
    const toggle = document.querySelector('.filters-toggle');
    const filters = document.getElementById('recipe-filters');
    if (!toggle || !filters)
        return;
    toggle.addEventListener('click', () => {
        const isOpen = filters.classList.toggle('is-open');
        toggle.classList.toggle('active', isOpen);
        toggle.setAttribute('aria-expanded', String(isOpen));
    });
}
